export enum ELoanProductOrderStep {
  FORM = 'FORM',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  COMMUNICATION_METHOD = 'COMMUNICATION_METHOD',
}
